module.exports = __webpack_public_path__ + "a23a91799249832d8cd8fb558c3bd3eb.png";